import { Anchor, Breadcrumbs, Grid, Text } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router';
import ErrorMessage from '../../components/ErrorMessage';
import FacebookProductSetForm from '../../components/Facebook/FacebookProductSetForm';
import Metadata from '../../components/Metadata';
import Spinner from '../../components/Spinner';
import { productsRangeToExport } from '../../constants/exportProductsRange';
import { Page } from '../../constants/pageTitles';
import useFetch from '../../helpers/useFetch';

const page = `${Page['facebookProductSet']}`;

const FacebookProductSetNewPage = () => {
  const { accountId, domainId } = useParams();
  const navigate = useNavigate();
  const fetch = useFetch();
  const location = useLocation();
  const facebookUser = useSelector((state) => state.facebook.user);

  const [segments, setSegments] = useState();
  const [loadError, setLoadError] = useState();

  useEffect(() => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/segments?scope=internal`)
      .then(({ segments }) => {
        setSegments(segments);
      })
      .catch(setLoadError);
  }, [accountId, domainId, fetch, location.search]);

  const create = (facebookProductSet) => {
    return fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/facebook/productSets`, {
      method: 'POST',
      body: JSON.stringify(facebookProductSet),
    }).then(() => {
      navigate(location.pathname.replace(`/facebook/productSets/new`, '/facebook/productSets'));
    });
  };
  if (facebookUser === null || segments === undefined) {
    return <Spinner />;
  }

  if (loadError) {
    return <ErrorMessage message={loadError.message} />;
  }

  const facebookProductSet = {
    name: 'New facebook product set',
    catalogId: facebookUser.catalogId,
    segmentId: segments[0]?.id,
    count: productsRangeToExport.min,
    status: false,
    type: 'ranked',
  };

  const breadcrumbItems = [
    { title: 'Home', href: `#/accounts/${accountId}/domains/${domainId}/analytics` },
    { title: page, href: `#/accounts/${accountId}/domains/${domainId}/facebook` },
    { title: 'New' },
  ].map((item, index) =>
    item.href ? (
      <Anchor href={item.href} key={index}>
        {item.title}
      </Anchor>
    ) : (
      <Text key={index}>{item.title}</Text>
    ),
  );

  return (
    <>
      <Metadata title={`${page} | New`} />
      <Breadcrumbs mb="md">{breadcrumbItems}</Breadcrumbs>
      <Grid>
        <Grid.Col span={12}>
          <FacebookProductSetForm
            facebookProductSet={facebookProductSet}
            segments={segments}
            saveFacebookProductSet={(facebookProductSet) => create(facebookProductSet)}
            cancel={() => navigate(`/accounts/${accountId}/domains/${domainId}/facebook/productSets`)}
          />
        </Grid.Col>
      </Grid>
    </>
  );
};

export default FacebookProductSetNewPage;
